module.exports = __webpack_public_path__ + "static/media/leg-left-back.24123171.png";